import { useEffect } from "react";
import { useFormikContext } from "formik";
import { useCountry } from "../context/CountryContext";

const getTeleCodeValue = (countryItem) => {
  if (!countryItem?.iso2 || countryItem.dialCode == null) return "";
  return `${countryItem.iso2}-${countryItem.dialCode}`;
};

const CountryFormSync = () => {
  const { selectedCountry, teleCode } = useCountry();
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (selectedCountry && selectedCountry !== values.country) {
      setFieldValue("country", selectedCountry);
      setFieldValue("state", "");
    }
  }, [selectedCountry, setFieldValue, values.country]);

  useEffect(() => {
    if (!selectedCountry || !teleCode?.length) return;

    const matched = teleCode.find(
      (item) => item.name?.toLowerCase() === selectedCountry.toLowerCase(),
    );
    if (!matched) return;

    const nextTeleCode = getTeleCodeValue(matched);
    if (nextTeleCode) {
      setFieldValue("telecode", nextTeleCode);
    }
  }, [selectedCountry, teleCode, setFieldValue]);

  return null;
};

export default CountryFormSync;
